/* eslint-disable no-unused-vars */
import React from 'react';
import styled, { keyframes } from 'styled-components';
import Menu from '../../../components/Menu/Navbar'
import { Link } from 'react-router-dom';
import Header from '../../../components/Header/header'
import Logo from '../../../components/Logo/logo'
import Footer from '../../../components/Footer/footer'
import { Lista, ContainerGeneral, Titulo, TituloChico, ElementoLista, TituloAzul, ContainerTexto } from '../../RioGrande/styletexto';
import FxView from '../../../components/FxView/fxview'
import FxImagenBackGround from '../../../components/FxImagenBackGround/fximagenbackground'

import { faSun } from '@fortawesome/free-solid-svg-icons';



const ContainerImagenes = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px; /* Espacio entre imágenes */
`;

const Imagen = styled.img`
  width: 100%; /* Ajusta este valor según necesites */
  max-width: 900px; /* Ajusta este valor para controlar el máximo ancho de las imágenes */
  height: auto; /* Para mantener la proporción de las imágenes */
  margin: 10px;
`;



const blinkAnimation = keyframes`
  0%, 100% {
    background-color: #000000;
    color: #a0f000;
  }
  50% {
    background-color: #a0f000;
    color: #000000;
  }
`;



const Boton = styled.a`
  font-size: 15px;
  width: 100%;
  font-family: 'Kobern'; /* Fuente para el botón */
  display: inline-block;
  margin-bottom: 16px;
  padding: 15px 20px;
  background-color: #a0f000; // Color inicial
  color: #000000; // Color del texto inicial
  text-align: center;
  border-radius: 5px;
  text-decoration: none;
  animation: ${blinkAnimation} 2s infinite; // Aplicar la animación aquí

  &:hover {
    background-color: #000000;
    color: #ffffff;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
`;


const MensajeExclusivo = styled.div`
 margin: 40px auto;
  max-width: 600px;
  padding: 20px;
  font-size: 16px;
position: relative;
  text-align: center;
  font-family: 'RNSMiles';
  background-color: #182329dc;
  color: #fff;
  border-radius: 15px;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.1);
  border: 1px solid #555;


`;

const BotonContacto = styled(Link)`
  font-family: 'Kobern'; /* Fuente para el botón */
  background-color: #a0f000 !important; /* Color de fondo del botón */
  color: #000000 !important; 
  cursor: pointer;
  width: 100%; /* Ancho del botón para que coincida con el input */
  border: none;
  outline: none;
  padding: 0.5em 1.5em;
  border-radius: 10px; /* Bordes redondeados */
  transition: all ease 0.125s;
  margin-top: 8px;
  text-align: center;
  display: block; /* Para que ocupe su propio espacio */
  color: inherit; /* Color del texto */
  text-decoration: none; /* Sin subrayado */

  &:hover {
    background-color: #000000 !important; /* Cambiar el color de fondo al pasar el mouse */
    color: #ffffff !important; /* Cambiar el color del texto al pasar el mouse */
  }
`;



const IntensivoDeNavidad = () => {
  return (
    <div>
      <Menu />
      <Header />
      <Logo />
      <FxView />

      <FxImagenBackGround icon={faSun} /> {/* Usar el nuevo icono aquí */}



      <ContainerGeneral>
        <ContainerTexto>





          <Titulo>INTENSIVO DE TENIS NSTA & M5 CLUB 2026</Titulo>



          <Lista>
            <ElementoLista> Este programa busca equilibrar la mejora técnica, táctica, física y mental, preparando a los jugadores para situaciones de competición intensa. Ajustando la intensidad y calendario de competición según las necesidades del jugador/a. <br /><br /> <strong>Próximamente más información. </strong></ElementoLista>
          </Lista>

          <br></br> <br></br> <br></br>



          {/* <ContainerImagenes>
            <Imagen src={require('./Intensivo Tenis  BHC 2025.jpg')} alt="cartelintensivo 1" />
          </ContainerImagenes>




          <ButtonContainer>
            <Boton href="https://docs.google.com/forms/d/e/1FAIpQLSdNaSnYWv4YBgqWq8eEP8HbSQWQw9FQ2H8MYD0GFcVefk5btg/viewform" target="_blank" rel="noopener noreferrer">
              INSCRIPCIÓN
            </Boton>
          </ButtonContainer>







          <Titulo>INSCRIPCIÓN INTENSIVO DE TENIS NSTA & BELLAVISTA HUELVA CLUB
          </Titulo>


          <Lista>
            <ElementoLista> <strong>Querida familia Net Sport Tennis Academy & BHC  </strong> <br></br><br></br>

              <strong>Abrimos el plazo de inscripción para el Intensivo de Tenis NSTA/BHC 2025

                <br></br><br></br>

                Está temporada los intensivos se realizarán desde el 30 de junio al 15 de Agosto. </strong> <br></br><br></br>

              Estamos ilusionados en poder realizar una temporada más el programa intensivo de entrenamientos específicos en alumnos/as de categorías inferiores (8 a 17 años) y adultos de todas las edades y niveles para que sean los grandes protagonistas del programa tenístico NSTA&BHC.
            </ElementoLista>


            <ElementoLista>
              No queremos dejar a nadie sin su plaza. Por ello, os informamos de que el <strong>periodo de reservas ya está abierto para todos/as</strong>. Para que todo sea más ágil y accesible, las inscripciones se harán online a través de nuestra web: <a href="https://www.netsportacademy.com" target="_blank " rel="noopener noreferrer">www.netsportacademy.com</a>
            </ElementoLista>




          </Lista>



          <Titulo>FORMAS DE INSCRIPCIÓN Y PAGO
          </Titulo>


          <TituloChico><strong>Solo ALUMNOS ESCUELA NSTA&BHC </strong></TituloChico>


          <Lista>
            <ElementoLista>
              El alumno/a tiene asegurada su plaza inscribiéndose antes del 10 de junio enviando su formulario de inscripción relleno al completo que encontraras en la pestaña Club - Bellavista Huelva Club – Intensivos de Tenis 2025 a través de nuestra web: <a href="https://www.netsportacademy.com" target="_blank " rel="noopener noreferrer">www.netsportacademy.com</a>
            </ElementoLista>
          </Lista>

          <Lista>
            <ElementoLista>
              El pago será exclusivamente por domiciliación bancaria (adjuntar en el formulario de inscripción sus datos de domiciliación bancaria). El cargo de la cuota íntegro se realizará en los primeros 10 días de julio.


            </ElementoLista>
          </Lista>



          <Lista>
            <ElementoLista>
              En el caso de querer causar baja una vez inscrito deberá enviar un mail a  bhctenispadel@gmail.com con un plazo mínimo de 10 días anterior a la fecha contratada, en caso contrario no se garantiza la devolución del pago.


            </ElementoLista>
          </Lista>

          <Lista>
            <ElementoLista>
              Concepto de baja: Nombre y Apellidos del alumno/a y del titular de la cuenta    + Fecha Contratada + Intensivo de Menores o Intensivo Adultos.


            </ElementoLista>
          </Lista>





          <TituloChico><strong>NOTA IMPORTANTE:  </strong></TituloChico>


          <Lista>
            <ElementoLista>
              Todas las nuevas inscripciones y pagos que sean suplementarios o posteriores a las fechas contratadas se deberán hacer rellenando un nuevo formulario de inscripción complementando de nuevo todos los campos del formulario y realizando el abono correspondiente a las nuevas fechas contratadas, dicha inscripción debe estar realizada, abonada y justificante enviado al mail bhctenispadel@gmail.com con un mínimo de tres días antes de la fecha de comienzo del alumno/a. 
            </ElementoLista>
          </Lista>

          <Lista>
            <ElementoLista>
            Por ejemplo: imaginemos que hemos inscrito una semana a nuestro hijo/a al Intensivo y cuando acaba queremos ampliarle una segunda. En primer lugar, habrá que preguntar a Alberto Martin si hay disponibilidad y, en segundo lugar, realizar todos los pasos expuestos en el párrafo anterior.


            </ElementoLista>
          </Lista>






          <Titulo>TENEMOS TRES TIPOS DE INTENSIVOS: </Titulo>

          <TituloAzul>INTENSIVO ESCUELA
          </TituloAzul>

          <TituloChico><strong>  30/06 al 15/08 / (Máximo 6/8 alumnos/as por pista y entrenador)   </strong></TituloChico>





          <Lista>

            <ElementoLista>
             El programa de entrenamiento que seguirán nuestros alumnos/as con edades entre los 8 y 17 años estará compuesto por:
           
            </ElementoLista>

            <br></br>

        
               <ElementoLista><strong>-	2 horas de entrenamiento de tenis en pista  </strong></ElementoLista>
            <ElementoLista><strong>-	1 hora de Preparación Física. </strong></ElementoLista>
            <ElementoLista><strong>-	Desayuno y deportes alternativos </strong></ElementoLista>
            <ElementoLista><strong>-	Piscina y juegos tradicionales</strong></ElementoLista>


          </Lista>


          <Lista>

            <br></br>
            <TituloChico><strong>PRECIOS</strong></TituloChico>  <br></br>
            <ElementoLista><strong>- 2 DÍAS: MARTES Y JUEVES: 55€ </strong></ElementoLista>
            <ElementoLista><strong>- 3 DÍAS: LUNES, MIERCOLES Y VIERNES: 70€</strong></ElementoLista>
            <ElementoLista><strong>- SEMANA: 100€ </strong></ElementoLista>

                <ElementoLista><strong>- SEMANA: 100€ </strong></ElementoLista>
                    <ElementoLista><strong>- QUINCENA: 190€  </strong></ElementoLista>
                        <ElementoLista><strong>- MES DE JULIO: 350€  </strong></ElementoLista>
                   

          </Lista>













          <TituloAzul>INTENSIVO COMPETICIÓN
          </TituloAzul>
          <TituloChico><strong>  30/07 al 15/08 / (Máximo 4 alumnos/as por pista y entrenador)
          </strong></TituloChico>





          <Lista>

            <ElementoLista>
            El programa de entrenamiento de competición está orientado a jugadores/as que compiten y compuesto por 2 horas de entrenamiento en pista y 1 hora de preparación física diaria y/o reglamentación, táctica de juego, trabajo mental deportivo …), todo ello con una planificación específica orientada a la competición., además tendrá 1 hora de acceso a la piscina del Club Bellavista Huelva Golf. <br></br>
            </ElementoLista>
                <ElementoLista><strong>De esta manera, el horario establecido será de lunes a viernes, de 09:00 a 13:00h ó 10:00 a 14:00 horas.</strong></ElementoLista><br></br>
                       <ElementoLista><strong>NOTA: El horario de piscina para los jugadores inscritos en el INTENSIVO DE COMPETICION será bajo la responsabilidad de madre, padre o tutor del menor, debiendo de rellenar y firmar el consentimiento del mismo, en caso contrario no tendrá acceso a la piscina. </strong></ElementoLista>

            <br></br>
            <TituloChico><strong>PRECIOS</strong></TituloChico>  <br></br>

            <ElementoLista><strong>- 3 DÍAS (LUNES, MIERCOLES Y VIERNES): 75€</strong></ElementoLista>
            <ElementoLista><strong>- SEMANA: 110€ </strong></ElementoLista>
        <ElementoLista><strong>- QUINCENA: 195€  </strong></ElementoLista>
             <ElementoLista><strong>- MES DE JULIO: 360€</strong></ElementoLista>
                 


          </Lista>






          <TituloAzul> ESCUELA DE VERANO ADULTOS 
          </TituloAzul>
          <TituloChico><strong> (Máximo 4 alumnos por pista y entrenador)
          </strong></TituloChico>



          <Lista>
            <ElementoLista>Los inscritos adultos entrenarán una hora y media, de 20:30 a 22:00 horas, los lunes y miércoles o martes y jueves. La escuela de verano tendrá lugar durante los meses de julio y agosto.  </ElementoLista>

            <br></br>
            <TituloChico><strong>PRECIOS</strong></TituloChico>  <br></br>
            <ElementoLista><strong>- MES: 75€</strong></ElementoLista>
         
   


            <br></br><br></br>

        

          </Lista>












          <Titulo>PARTICULARES
          </Titulo>




          <TituloChico><strong>- ¡RESERVA TU CLASE!</strong></TituloChico>

          <Lista>
            <ElementoLista><strong>- INDIVIDUAL</strong> de 1 hora: <strong>30€ </strong> </ElementoLista>
            <ElementoLista><strong>- 2 JUGADORES</strong> de 1 hora: <strong>40€ </strong> </ElementoLista>
            <ElementoLista><strong>- ENTRENADOR SPARRING</strong> de 1 hora: <strong>35 €</strong></ElementoLista>

            <br></br><br></br>

            <TituloChico><strong>- HORARIO:</strong></TituloChico> 

            <ElementoLista>
             De lunes a viernes de 08:00 a 09:00 horas o a partir de las 18:00 horas de lunes a jueves. Para reservar día/hora y consultar disponibilidad llamar o enviar WhatsApp al teléfono de NSTA&BHC <strong>638 35 57 69 o 645 67 69 85 </strong><br></br>
            </ElementoLista>

            <ElementoLista>
             Para cualquier duda pueden contactar al siguiente teléfono de contacto BHC Tenis&Padel 645 676 985 para exponer la cuestión pertinente en horario de 10:00 a 14:00 horas.   <br></br>
            </ElementoLista>

            <ElementoLista>
             Finalmente, queremos aprovechar este comunicado para agradeceros la confianza que cada año demostráis tener en nuestro proyecto para que sigamos creciendo todos juntos.  <br></br>
            </ElementoLista>
          </Lista>





          <br></br><br></br><br></br>
          <ContainerImagenes>



            <MensajeExclusivo>
              <p>Acceso Exclusivo para Socios de la Academia</p>
              <p>¿Interesado en La planificación de Intensivo? Únete a nuestra familia de <br></br>NET SPORT ACADEMY. ¡Contacta con el equipo para resolver cualquier duda!</p>
              <BotonContacto to="/contacto">CONTACTO</BotonContacto>
            </MensajeExclusivo>


            <Imagen src={require('./intensivos1.jpg')} alt="Intensivos 1" />
     


          </ContainerImagenes> */}





        </ContainerTexto>
      </ContainerGeneral>

      <Footer />
      <></>
    </div>
  )
}

export default IntensivoDeNavidad
